"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.StandardHotspotArrow = exports.StandardHotspotStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

var _boundingBox = require("../../components/bounding-box");

var _hotspot3 = require("../../hotspot.utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var boxShadow = "0 0 10px 0 ".concat((0, _hotspot3.setOpacity)(_hotspotGlobal.colors.pavlova, 0.3));

var StandardHotspotStyled = _styledComponents.default.span.withConfig({
  displayName: "StandardHotspotstyles__StandardHotspotStyled",
  componentId: "sc-18zph6o-0"
})(["font-family:Poppins,sans-serif;letter-spacing:0.05em;background:", ";border-radius:0.3em;box-shadow:", ";color:", ";font-size:2.1em;line-height:1em;opacity:", ";padding:0.5em 1em;position:absolute;text-align:center;top:", "%;left:", "%;transform:", ";white-space:nowrap;"], function (_ref) {
  var config = _ref.config;
  return config.backgroundColor;
}, boxShadow, function (_ref2) {
  var config = _ref2.config;
  return config.color;
}, function (_ref3) {
  var config = _ref3.config;
  return config.opacity;
}, function (_ref4) {
  var iconPosition = _ref4.iconPosition;
  return iconPosition.top;
}, function (_ref5) {
  var iconPosition = _ref5.iconPosition;
  return iconPosition.left;
}, _hotspotGlobal.translateXY);

exports.StandardHotspotStyled = StandardHotspotStyled;

var StandardHotspotArrow = _styledComponents.default.span.withConfig({
  displayName: "StandardHotspotstyles__StandardHotspotArrow",
  componentId: "sc-18zph6o-1"
})(["height:1em;left:50%;overflow:hidden;position:absolute;top:95%;transform:translateX(-50%);width:2em;&:after{background:", ";box-shadow:", ";content:'';height:1em;left:50%;position:absolute;transform:translateX(-50%) translateY(-50%) rotate(45deg);top:0;width:1em;}"], function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor;
}, boxShadow);

exports.StandardHotspotArrow = StandardHotspotArrow;
var hoverState = "\n".concat(_boundingBox.FourCornersStyled, " {\n  opacity: 1;\n}\n").concat(StandardHotspotStyled, " {\n  opacity: 0;\n}\n");
var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "StandardHotspotstyles__ClickableAreaStyled",
  componentId: "sc-18zph6o-2"
})(["", ""], function (_ref7) {
  var disableHover = _ref7.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, hoverState, function (_ref8) {
    var previewHoverState = _ref8.previewHoverState;
    return previewHoverState && hoverState;
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;